import { Component, Input, OnInit } from '@angular/core';

import { Store } from '@ngxs/store';
import { ReactivateDrill } from 'src/app/drills-user/state/drills.actions';
import { TenantUserPrivilegesService } from 'src/app/tenant-selector/services/tenant-user-privileges.service';
import { UserDrillsRoutes } from '../../../../../core/enums/routes.enum';
import { Privileges } from '../../../../../core/privileges/privileges';

@Component({
  selector: 'app-drills-overview-template',
  templateUrl: './drills-overview-template.component.html',
  styleUrls: ['./drills-overview-template.component.scss'],
  standalone: false,
})
export class DrillsOverviewTemplateComponent implements OnInit {
  @Input() columnName: string;
  @Input() element: any;
  performRoute = UserDrillsRoutes.Perform;
  Privileges = Privileges;
  hasPermissionToPerform = false;

  constructor(
    private store: Store,
    private tenantUserPrivileges: TenantUserPrivilegesService
  ) {}

  ngOnInit(): void {
    this.hasPermissionToPerform = this.tenantUserPrivileges.userHasPrivilege(
      Privileges.DrillPerform
    );
  }

  reactivate(): void {
    this.store.dispatch(new ReactivateDrill(this.element.id));
  }
}
